import { useState } from 'react';
import copyTextToClipboard from '@uiw/copy-to-clipboard';
import { CopyIcon, CopySuccessIcon } from "./icons.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var Copied = props => {
  var [copied, setCopied] = useState(false);
  var handle = () => {
    setCopied(true);
    copyTextToClipboard(props.text || '', () => {
      var timer = setTimeout(() => {
        setCopied(false);
        clearTimeout(timer);
      }, 2000);
    });
  };
  return /*#__PURE__*/_jsx("button", {
    onClick: handle,
    children: copied ? /*#__PURE__*/_jsx(CopySuccessIcon, {}) : /*#__PURE__*/_jsx(CopyIcon, {})
  });
};